(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery(document).ready(function ($) {
  $('.site-switch').on('click', function (event) {
    // Allows anchor link to be clicked without closing dropdown
    event.stopPropagation();

    // If expanded, collapse
    if ($(this).hasClass('site-switch-expanded')) {
      $(this).children('.bjc-faq-answer').animate({
        height: 0
      }, 100, 'linear');
    } else {
      $(this).children('site-switch-option').animate({
        height: $('.site-switch-dropdown').children('.site-switch-option').get(0).scrollHeight
      }, 100, 'linear', function () {
        $(this).children('site-switch-option').height('auto'); // After animation set height to auto top avoid resizing issues
      });
    }
    $(this).toggleClass('site-switch-expanded');
  });
});

},{}]},{},[1]);
